import $ from 'jquery'
import Block from '../../common.blocks/block'
import { MDCTextField } from '@material/textfield'

export default class Choices extends Block {
	static title = 'choices'

	constructor($el) {
		super($el)

		// Initialize properties
		this.data = new FormData(this.$el.get(0))
		this.data.append('ajax', true)

		this.page = this.$el
			.find('.choices__options')
			.not('.choices__options--hidden')
			.index()
		this.choiceContainer = this.$el
		this.steps = this.$el.find('.choices__center')
		this.choice = $('.choices__options')
		this.buttons = this.$el.find('.choices__bottom .button')
		this.next = $('.choices__bottom .button--next')
		this.prev = $('.choices__bottom .button--prev')
		this.showChoice = $('.button--show-choice')
		this.closeChoice = $('.button--hide-choice')

		// Initialize events
		this.initEvents()
	}

	/**
	 * Initialize event listeners for buttons and actions.
	 */
	initEvents() {
		this.buttons.on('click', (e) => this.handleStepChange(e))
		this.showChoice.on('click', () => this.toggleChoiceContainer(false))
		this.closeChoice.on('click', () => this.toggleChoiceContainer(true))
		this.$el.on('click', (e) => {
			if ($(e.target).hasClass('email_send')) {
				this.handleFormSubmit()
			}
		})
	}

	/**
	 * Toggle the visibility of the choice container.
	 * @param {boolean} hide - Whether to hide the container.
	 */
	toggleChoiceContainer(hide) {
		this.choiceContainer.toggleClass('choices--hidden', hide)
	}

	/**
	 * Handle step navigation (next/previous).
	 * @param {Event} event - The click event from the button.
	 */
	handleStepChange(event) {
		const $button = $(event.currentTarget)
		const isNext = $button.hasClass('button--next')
		const isPrev = $button.hasClass('button--prev')
		const dataStep = 'property_id[]'
		const dataStepText = 'property_text[]'

		if (!this.isValidStep(isNext, dataStep)) return

		if (isPrev) this.resetStepData(dataStep)
		this.updateStepData(dataStep, dataStepText)
		this.updateStep(isNext, $button)

		if (isNext) this.handleOptionSubmit()
	}

	/**
	 * Validate if the current step is valid to proceed.
	 * @param {boolean} isNext - Whether it's the next step.
	 * @param {string} dataStep - The data step type.
	 * @returns {boolean}
	 */
	isValidStep(isNext, dataStep) {
		if (isNext && this.getCheckedOptionsValues(dataStep).length === 0) {
			$(document).trigger('message:error', 'Deze stap is vereist')
			return false
		}
		return true
	}

	/**
	 * Reset step data for previous navigation.
	 * @param {string} dataStep - The data step type.
	 */
	resetStepData() {
		$(this.choice[this.page]).find('.choice__input').val('')
	}

	/**
	 * Update the step data in the FormData object.
	 * @param {string} dataStep - The data step type.
	 */
	updateStepData(dataStep, dataStepText) {
		this.data.delete(dataStep)
		this.data.delete(dataStepText)
		const values = this.getCheckedOptionsValues(dataStep)
		values.forEach((value) => this.data.append(dataStep, value))
		const valuesText = this.getCheckedOptionsTextValues(dataStep, dataStepText)
		valuesText.forEach((value) => this.data.append(dataStepText, value))
	}

	/**
	 * Change the step UI and update state.
	 * @param {boolean} isNext - Whether to go to the next step.
	 * @param {jQuery} $button - The clicked button element.
	 */
	updateStep(isNext) {
		$(this.choice[this.page]).addClass('choices__options--hidden')
		if (isNext) {
			this.page += 1
			this.addNewStep()
		} else {
			this.page -= 1
			this.removeStep()
			this.next.removeClass('button--disabled')
		}

		this.data.set('page', this.page)
		this.updatePrevButtonsState()
		$(this.choice[this.page]).removeClass('choices__options--hidden')
	}

	/**
	 * Add a new step container dynamically.
	 */
	addNewStep() {
		const newStep = $('<div/>').addClass(
			'choices__options choices__options--hidden',
		)
		$(this.choice[this.page - 1]).after(newStep)
		this.choice[this.page] = newStep
	}

	/**
	 * Remove the current step and update the previous step's UI.
	 */
	removeStep() {
		$(this.choice[this.page + 1]).remove()
		this.removePreviousStepUI()
		this.updatePreviousStepUI()
	}

	/**
	 * Remove the UI for the previous step.
	 */
	removePreviousStepUI() {
		const currentSelector = `${this.page + 2}`

		$(`.products_count .product_count_${currentSelector}`).remove()
		$(`.choice_text_${currentSelector}`).remove()
		$(`.choice_description_${currentSelector}`).remove()
	}

	/**
	 * Update the UI for the previous step.
	 */
	updatePreviousStepUI() {
		const previousSelector = `${this.page + 1}`
		$(`.products_count .product_count_${previousSelector}`).removeClass(
			'product_count--hidden',
		)
		$(`.choice_text_${previousSelector}`).removeClass('choice_text--hidden')
		$(`.choice_description_${previousSelector}`).removeClass(
			'choice_description--hidden',
		)
	}

	/**
	 * Enable or disable buttons based on the current step.
	 */
	updatePrevButtonsState() {
		this.prev.toggleClass('button--disabled', this.page === 0)
	}

	/**
	 * Get all selected option values for the current step.
	 * @param {string} dataStep - The data step type.
	 * @returns {Array} - List of checked option values.
	 */
	getCheckedOptionsValues(dataStep) {
		return $(this.steps)
			.find(`.choices__options input[data-type="${dataStep}"]:checked`)
			.map((_, input) => $(input).val())
			.get()
	}

	getCheckedOptionsTextValues(dataStep, dataStepText) {
		return $(this.steps)
			.find(`.choices__options input[data-type="${dataStep}"]:checked`)
			.map((_, input) => {
				// Find the closest hidden input with the corresponding data-type
				const hiddenInput = $(input)
					.closest('label.choice')
					.find(`input[data-type="${dataStepText}"]`)
				return hiddenInput.val() // Return its value
			})
			.get()
	}

	/**
	 * Submit options for the current step via AJAX.
	 */
	handleOptionSubmit() {
		this.data.set('add', 1)
		this.data.set('ajax', 1)
		this.data.set('category', $('.choices__center').attr('data-choice'))
		$(this.choice[this.page]).empty()

		const loadingElement = $('.choices__loading')
		loadingElement.show()
		this.prev.toggleClass('button--disabled')

		$.ajax({
			method: 'POST',
			processData: false,
			contentType: false,
			cache: false,
			url: '/choice',
			data: this.data,
		})
			.done((response) => this.handleOptionResponse(response))
			.fail((error) => this.handleAjaxError(error))
			.always(() => {
				loadingElement.hide()
				this.prev.toggleClass('button--disabled')
			})
	}

	/**
	 * Handle the response from the option submit request.
	 * @param {Object} response - The AJAX response data.
	 */
	handleOptionResponse(response) {
		if (response.error) {
			$(document).trigger('message:error', response.error)
			return
		}

		if (response.is_product) {
			this.next.addClass('button--disabled')
		}

		$(this.choice[this.page]).html(response.html)

		// Reinitialize MDCTextField on newly added text fields
		this.reinitializeMdcTextFields()

		this.updateStepUI(response)
	}

	/**
	 * Update the UI for the current step based on the response data.
	 * @param {Object} response - The response data.
	 */
	updateStepUI(response) {
		const pageClass = parseInt(response.page, 10) + 1 // Increment page to match the desired page number

		// Create new elements with page-specific classes
		const productCount = $('<strong/>')
			.addClass('product_count')
			.text(`${response.count} producten gevonden`)
			.addClass(`product_count_${pageClass}`) // Page-specific class
		const choiceText = $('<strong/>')
			.addClass('text')
			.addClass('choice_text')
			.text(response.property_name)
			.addClass(`choice_text_${pageClass}`) // Page-specific class
		const choiceDescription = $('<span/>')
			.addClass('text')
			.addClass('choice_description')
			.text(response.property_description)
			.addClass(`choice_description_${pageClass}`) // Page-specific class

		// Duplicate the elements by appending them after the current content
		$(`.products_count .product_count_${response.page}`).after(productCount)
		$(`.choice_text_${response.page}`).after(choiceText)
		$(`.choice_description_${response.page}`).after(choiceDescription)

		// Content before current step set to hidden
		$(`.product_count_${response.page}`).addClass('product_count--hidden')
		$(`.choice_text_${response.page}`).addClass('choice_text--hidden')
		$(`.choice_description_${response.page}`).addClass(
			'choice_description--hidden',
		)
	}

	/**
	 * Handle form submission via AJAX.
	 */
	handleFormSubmit() {
		const formData = new FormData()
		formData.set('form_id', $('input[name="form_id"]').val())
		this.collectFormData(formData)

		const emailButton = $('.email_send')
		const loadingElement = emailButton.find('.choices__loading-form')
		const buttonText = emailButton.find('.button-text')
		const buttonIcon = emailButton.find('.button__icon')

		// Show loader, hide text & icon
		buttonText.hide()
		buttonIcon.hide()
		loadingElement.show()

		$.ajax({
			method: 'POST',
			processData: false,
			contentType: false,
			cache: false,
			url: '/choice',
			data: formData,
		})
			.done((json) => {
				if (!json.error) {
					window.location.href = '/bedankt-pagina-keuzehulp'
				}
			})
			.fail((error) => this.handleAjaxError(error))
			.always(() => {
				// Restore original text & icon, hide loader
				loadingElement.hide()
				buttonText.show()
				buttonIcon.show()
			})
	}

	/**
	 * Collect all form data, including selected choices.
	 * @param {FormData} formData - The FormData object to populate.
	 */
	collectFormData(formData) {
		// First, clear any previous values for options in formData
		formData.delete('fields[option][]') // Remove previous values of option array

		// Serialize and append all fields from the form except checkboxes
		$('form[name="choices"]')
			.serializeArray()
			.forEach((input) => {
				// Append each field's value to the formData object
				if (input.name != 'fields[option][]' && input.name != 'options[]') {
					formData.append(input.name, input.value)
				}
			})

		// Loop through all the checked checkboxes and append their values
		$('form[name="choices"] input[type="checkbox"]:checked').each(
			(_, checkbox) => {
				const $checkbox = $(checkbox)
				const checkboxName = $checkbox.attr('name')
				const checkboxValue = $checkbox.val()

				// Append the checkbox value to formData
				formData.append(checkboxName, checkboxValue)

				// Find the associated hidden field for this checkbox
				const hiddenField = $checkbox
					.closest('label')
					.find('input[type="hidden"][name="fields[option][]"]')

				// Append the value of the hidden field to formData if it exists
				if (hiddenField.length > 0) {
					formData.append(hiddenField.attr('name'), hiddenField.val())
				}
			},
		)

		// Additional fields like form_id, submit button, etc.
		formData.append('form_id', 8) // Example static value
		formData.append('submit', 1) // Example static value
	}

	/**
	 * Handle AJAX errors.
	 * @param {Object} error - The error object.
	 */
	handleAjaxError(error) {
		// console.error('AJAX error:', error)
		$(document).trigger('message:error', error.message)
	}

	/**
	 * Reinitialize MDCTextField components after AJAX load.
	 */
	reinitializeMdcTextFields() {
		$(this.choice[this.page])
			.find('.mdc-text-field')
			.each((_, el) => {
				new MDCTextField(el)
			})
	}
}
